var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.8333C3.77826 12.8333 1.16667 10.2218 1.16667 7C1.16667 3.77826 3.77826 1.16667 7 1.16667C10.2218 1.16667 12.8333 3.77826 12.8333 7C12.8333 10.2218 10.2218 12.8333 7 12.8333ZM7 11.6667C8.23768 11.6667 9.42467 11.175 10.2998 10.2998C11.175 9.42467 11.6667 8.23768 11.6667 7C11.6667 5.76233 11.175 4.57534 10.2998 3.70017C9.42467 2.825 8.23768 2.33334 7 2.33334C5.76233 2.33334 4.57534 2.825 3.70017 3.70017C2.825 4.57534 2.33334 5.76233 2.33334 7C2.33334 8.23768 2.825 9.42467 3.70017 10.2998C4.57534 11.175 5.76233 11.6667 7 11.6667ZM7.58334 7H9.91667V8.16667H6.41667V4.08334H7.58334V7Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.83e5ba5a.svg";
export { ForwardRef as ReactComponent };